import { Button, Stack, Typography, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';
import { useCandidateProfileContext } from './hooks/use-candidate-profile-context';

const useStyles = makeStyles(theme => ({
  mainDiv: {
    padding: '0.625rem 1rem',
    borderBottom: `1px solid ${theme.palette.border.primaryBlack3}`,
  },
  flexDiv: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconDiv: {
    width: '2.5rem',
    height: '2.5rem',
    padding: '0.5rem',
    cursor: 'pointer',
    position: 'relative',
  },
  rightDiv: {
    width: '100%',
    justifyContent: 'space-around',
  },
  jobRole: {
    textAlign: 'center',
  },
  candidateNumber: {
    color: theme.palette.content.primaryBlack3,
    textAlign: 'center',
  },
}));

const ProfileHeader = ({
  jobRole,
  candidateNumber,
  totalCandidates,
  onClose,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
}) => {
  // hooks
  const classes = useStyles();
  const { isLoading } = useCandidateProfileContext();

  // variables
  const showHeader =
    jobRole ||
    onClose ||
    onPrevious ||
    onNext ||
    candidateNumber ||
    totalCandidates ||
    hasPrevious ||
    hasNext;

  return (
    showHeader && (
      <div className={classes.mainDiv}>
        <Stack className={classes.flexDiv}>
          {onClose && (
            <Stack
              onClick={() => {
                onClose();
              }}
              className={classes.iconDiv}
            >
              <Iconify icon="tabler:x" />
            </Stack>
          )}
          <Stack className={classes.rightDiv} direction="row">
            {onPrevious && (
              <Button
                disabled={!hasPrevious}
                onClick={onPrevious}
                startIcon={<Iconify icon="tabler:chevron-left" />}
                variant="text"
              >
                Previous applicant
              </Button>
            )}
            <Stack spacing="2px">
              <Typography
                variant="subheading1"
                fontSize={16}
                className={classes.jobRole}
              >
                {jobRole}
              </Typography>

              {candidateNumber && totalCandidates && (
                <Typography
                  variant="caption"
                  className={classes.candidateNumber}
                >
                  {candidateNumber} of {totalCandidates}
                </Typography>
              )}
            </Stack>
            {onNext && (
              <Button
                disabled={!hasNext}
                onClick={onNext}
                variant="text"
                endIcon={<Iconify icon="tabler:chevron-right" />}
              >
                Next applicant
              </Button>
            )}
          </Stack>
        </Stack>
      </div>
    )
  );
};

export default ProfileHeader;

ProfileHeader.propTypes = {
  jobRole: PropTypes.string,
  candidateNumber: PropTypes.number,
  totalCandidates: PropTypes.number,
  onClose: PropTypes.func,
  hasPrevious: PropTypes.bool,
  hasNext: PropTypes.bool,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
};
